import { motion } from "framer-motion";

export default function SpecSheet({ groups }) {
  if (!groups?.length) return null;
  return (
    <section className="border-t border-navy-ink/5 bg-navy-light/60 px-6 py-20 lg:px-12 lg:py-28" data-testid="yacht-spec-sheet">
      <div className="mx-auto max-w-7xl">
        <div className="mb-14 flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
          <h2 className="brand-heading brand-ink font-serif text-4xl font-light tracking-tight text-navy-ink sm:text-5xl">
            Full <span className="italic text-gold-light">specification.</span>
          </h2>
          <p className="max-w-sm text-xs font-light leading-relaxed text-mist">
            Figures as published by the shipyard; subject to change and final specification at the time of order.
          </p>
        </div>
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          {groups.map((g, gi) => (
            <motion.div
              key={g.group}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.8, delay: gi * 0.08 }}
              data-testid={`yacht-spec-group-${gi}`}
            >
              <p className="border-b border-gold/40 pb-3 text-[10px] uppercase tracking-[0.35em] text-gold">{g.group}</p>
              <dl>
                {g.items.map((it) => (
                  <div key={it.label} className="flex items-baseline justify-between gap-4 border-b border-navy-ink/10 py-4">
                    <dt className="text-[11px] uppercase tracking-[0.2em] text-mist">{it.label}</dt>
                    <dd className="text-right font-serif text-lg text-navy-ink">{it.value}</dd>
                  </div>
                ))}
              </dl>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
